import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function tableCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'tableCell',
    baseStyle: {
      fontSize: theme.sizes['0'],
      gap: theme.space['4xs'],

      '&:first-child': {
        paddingLeft: theme.space['s']
      },

      '&:last-child': {
        paddingRight: theme.space['s']
      }
    },
    variants: {
      insideCard: {}
    }
  };
}
